import { render, staticRenderFns } from "./customer-invoice-data.vue?vue&type=template&id=10cbe660"
import script from "./customer-invoice-data.vue?vue&type=script&lang=js"
export * from "./customer-invoice-data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports